import { Label } from "buoy-core"
import styled from "styled-components"

const HeaderLabel = styled(Label)`
  color: #96cdff;
  margin: 16px 0 20px;
`

export default HeaderLabel



// WEBPACK FOOTER //
// ./assets/feedback/components/postIntent/components/HeaderLabel.js